module.exports = __webpack_public_path__ + "static/media/ea_accountabilities.74a41c1f.png";